import { DayTimetable, WeekTimetable } from 'z3k-config';
export function createWeekTimetableWithZeroes(config) {
    const dayIds = new Array(7).fill(0).map(() => {
        let dayId;
        [dayId, config] = DayTimetable.get.add(config, {
            // prettier-ignore
            temp24: [
                0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0,
                0, 0, 0, 0, 0, 0, 0, 0,
            ],
        });
        return dayId;
    });
    let weekId;
    [weekId, config] = WeekTimetable.get.add(config, {
        temp7: dayIds,
    });
    return [weekId, config];
}
